// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ApplyRouteImport } from './routes/apply'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ComplaintsRouteImport } from './routes/complaints'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ResponsibleLendingRouteImport } from './routes/responsible-lending'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardApplicationsRouteImport } from './routes/dashboard/applications'
import { Route as DashboardProfileRouteImport } from './routes/dashboard/profile'
import { Route as DashboardSettingsRouteImport } from './routes/dashboard/settings'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const ApplyRoute = ApplyRouteImport.update({
            id: '/apply',path: '/apply',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const ComplaintsRoute = ComplaintsRouteImport.update({
            id: '/complaints',path: '/complaints',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CookiePolicyRoute = CookiePolicyRouteImport.update({
            id: '/cookie-policy',path: '/cookie-policy',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ResponsibleLendingRoute = ResponsibleLendingRouteImport.update({
            id: '/responsible-lending',path: '/responsible-lending',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const DashboardIndexRoute = DashboardIndexRouteImport.update({
            id: '/dashboard/',path: '/dashboard/',getParentRoute: () => rootRouteImport
          })
const DashboardApplicationsRoute = DashboardApplicationsRouteImport.update({
            id: '/dashboard/applications',path: '/dashboard/applications',getParentRoute: () => rootRouteImport
          })
const DashboardProfileRoute = DashboardProfileRouteImport.update({
            id: '/dashboard/profile',path: '/dashboard/profile',getParentRoute: () => rootRouteImport
          })
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
            id: '/dashboard/settings',path: '/dashboard/settings',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AdminRoute: AdminRoute,ApplyRoute: ApplyRoute,AuthRoute: AuthRoute,ComplaintsRoute: ComplaintsRoute,ContactRoute: ContactRoute,CookiePolicyRoute: CookiePolicyRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ResponsibleLendingRoute: ResponsibleLendingRoute,ServicesRoute: ServicesRoute,TermsRoute: TermsRoute,DashboardApplicationsRoute: DashboardApplicationsRoute,DashboardProfileRoute: DashboardProfileRoute,DashboardSettingsRoute: DashboardSettingsRoute,DashboardIndexRoute: DashboardIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)